import { z } from "zod";

export type NurseBulkFormValues = z.infer<typeof NurseBulkSchema>;

export const NurseBulkSchema = z
  .object({
    role: z.string().nullable().optional(),
    level_: z.string().optional(),
    weekly_off_weekday: z.number().nullable(),
    is_head_nurse: z.boolean(),
    allowed_shifts: z.array(z.string()),
    preceptor_id: z.string().nullable(),
    exclusion_partner_id: z.string().nullable().optional(),
    joining_date: z.string().nullable().optional(),
    resignation_date: z.string().nullable().optional(),
    nurse_memo: z.string().nullable(),
    grade: z.number().nullable().optional(),
    experience: z.number().min(0).optional(),
    is_weekend_off: z.boolean().nullable().optional(),
    fixed_shift: z.string().nullable().optional(),
    enable_aide: z.boolean(),
    enable_nurse_pair_preference: z.boolean(),
    wanted_max_requests: z.number().nullable().optional(),
  })
  .refine(
    (data) => {
      // 입사일과 퇴사일이 모두 존재할 때만 비교
      if (data.joining_date && data.resignation_date) {
        return data.joining_date <= data.resignation_date;
      }
      return true;
    },
    {
      message: "퇴사일은 입사일 이후여야 합니다",
      path: ["resignation_date"],
    }
  );
